(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["munchkin-flow-guide"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('flow-guide')) {
  customElements.define('flow-guide', class extends HTMLElement {
    connectedCallback() {
      if (this.flowReady) return;
      this.flowReady = true;
      this.dialog = this.querySelector('dialog');
      this.player = this.querySelector('.flow-guide__player');
      this.addEventListener('click', event => {
        if (event.target.closest('[data-flow-close]')) { this.dialog.close(); return; }
        const link = event.target.closest('[data-flow-video]');
        if (!link || !/^[a-zA-Z0-9]+$/.test(link.dataset.flowVideo)) return;
        event.preventDefault();
        this.querySelector('video')?.pause();
        this.lastTrigger = link;
        this.dialog.querySelector('h2').textContent = link.dataset.flowTitle;
        this.dialog.toggleAttribute('data-square', !!link.closest('#flow-stories'));
        const frame = document.createElement('iframe');
        frame.src = 'https://player.mux.com/' + link.dataset.flowVideo + '?autoplay=true';
        frame.title = link.dataset.flowTitle;
        frame.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen';
        frame.allowFullscreen = true;
        this.player.replaceChildren(frame);
        this.dialog.showModal();
      });
      this.dialog.addEventListener('close', () => { this.player.replaceChildren(); this.lastTrigger?.focus(); });
      this.dialog.addEventListener('click', event => { if (event.target === this.dialog) { const r=this.dialog.getBoundingClientRect(); if(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom) this.dialog.close(); } });
    }
    disconnectedCallback() { this.player?.replaceChildren(); }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["munchkin-home-slideshow"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('munchkin-home-slider')){
 customElements.define('munchkin-home-slider',class extends HTMLElement{
  connectedCallback(){
   this.abort=new AbortController();const track=this.querySelector('.mhs__track');const slides=[...this.querySelectorAll('.mhs__slide')];const dots=[...this.querySelectorAll('[data-slide]')];let current=0;
   const update=()=>{current=Math.round(track.scrollLeft/track.clientWidth);dots.forEach((d,i)=>d.setAttribute('aria-pressed',String(i===current)));const prev=this.querySelector('[data-step="-1"]');const next=this.querySelector('[data-step="1"]');if(prev)prev.disabled=current===0;if(next)next.disabled=current===slides.length-1;};
   this.addEventListener('click',e=>{const b=e.target.closest('button');if(!b)return;const idx=b.hasAttribute('data-slide')?Number(b.dataset.slide):current+Number(b.dataset.step);if(!Number.isFinite(idx))return;track.scrollTo({left:Math.max(0,Math.min(slides.length-1,idx))*track.clientWidth,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});},{signal:this.abort.signal});
   track.addEventListener('scroll',update,{passive:true,signal:this.abort.signal});this.addEventListener('shopify:block:select',e=>{const i=slides.indexOf(e.target);if(i>=0)track.scrollTo({left:i*track.clientWidth});},{signal:this.abort.signal});update();
  }
  disconnectedCallback(){this.abort?.abort();}
 });
}

  } catch(e) { console.error(e); }
})();
})();
